/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { addThrottledEvent, Module, Node } from '@msdyn365-commerce-modules/utilities';
import { ICoreContext } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IDobbiesAccountMenuViewProps } from './dobbies-account-menu';

export default (props: IDobbiesAccountMenuViewProps) => {
    const { className, links, contentBlockContainer, resources, dropDownLinks } = props;
    const [screenSize, setScreenSize] = React.useState(0); // mobile first approach
    const [, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        setMobileView();
        window && addThrottledEvent(window, 'resize', setMobileView);
    });

    const setMobileView = () => {
        const _isMobile = isMobileView(props.context);
        setIsMobile(_isMobile);
    };

    React.useEffect(() => {
        const isMbl = _getScreenSize(props.context);
        setScreenSize(isMbl);
    });
    const _getScreenSize = (ctx: ICoreContext): number => {
        // always render in mobile viewport on a mobile device
        // if (ctx.request && ctx.request.device && ctx.request.device.Type === 'Mobile') {
        //     return 1;
        // }

        if (typeof window !== undefined && window.innerWidth) {
            const gridSettings = ctx.request.gridSettings;
            if (gridSettings) {
                if (gridSettings.xs && window.innerWidth < gridSettings.xs.w) {
                    // mobile
                    return 1;
                } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
                    // iPad
                    return 2;
                } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                    // Desktop
                    return 3;
                } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                    // Desktop
                    return 3;
                } else {
                    return 3;
                }
            }
        }

        return 3; // desktop
    };
    if (screenSize > 0 && screenSize <= 2) {
        return (
            <Module {...contentBlockContainer}>
                <h2>{resources.headingText}</h2>
                <Node className={className!}>{dropDownLinks}</Node>
            </Module>
        );
    }
    return (
        <Module {...contentBlockContainer}>
            <h2>{resources.headingText}</h2>
            <Node className={className!}>{links}</Node>
        </Module>
    );
};

/* VSI Customization - START */
const isMobileView = (context: ICoreContext): boolean => {
    // always render in mobile viewport on a mobile device
    /* if (context.request && context.request.device && context.request.device.Type === 'Mobile') {
        return true;
    } */

    if (typeof window !== undefined && window.innerWidth) {
        const gridSettings = context.request.gridSettings;
        if (gridSettings) {
            if (gridSettings.xs && window.innerWidth < gridSettings.xs.w) {
                return true;
            } else if (gridSettings.sm && window.innerWidth < gridSettings.sm.w) {
                return true;
            } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                return false;
            } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                return false;
            } else {
                return false;
            }
        }
    }

    return false;
};
/* VSI Customization - END */
